import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { BackToTop } from "./components/shared";
import "./styles/App.css";
import "./styles/Globals.css";
import routesConfig from "./utils/routesConfig.js";
import { HelmetProvider } from "react-helmet-async";
import { messaging } from "./integrations/Firebase";
import { onMessage } from 'firebase/messaging'; // Added getToken for potential future use
import { detectFeatures } from './utils/biometricUtils.js'

const App = () => {
  const queryClient = new QueryClient();

  useEffect(() => {
    if (process.env.REACT_APP_ENV === 'Development') {
      return
    }
    // Set up the onMessage listener for foreground messages
    const unsubscribe = onMessage(messaging, async (payload) => {
      const messageTitle = payload.notification ? payload.notification.title : payload.data.title;
      const messageBody = payload.notification ? payload.notification.body : payload.data.body;
      const messageIcon = payload.data.icon || '/logo192.png'; // Use a default or icon from payload
      const clickAction = payload.data.click_action || '/'; // Default click action
      const { source } = await detectFeatures();
      if (Notification.permission === 'granted' && source === 'app') {
        const notification = new Notification(messageTitle, {
          body: messageBody,
          icon: messageIcon,
          data: {
            url: clickAction // Store the URL to open on clickF
          }
        });

        // Optional: Handle notification click in foreground
        notification.onclick = (event) => {
          event.preventDefault(); // Prevent default browser action
          window.focus(); // Bring the app to focus
          if (notification.data && notification.data.url) {
            window.location.href = notification.data.url; // Navigate to URL
          }
          notification.close();
        };
      } else {
        toast.success(messageTitle + ': ' + messageBody, {
          position: "top-right",
          autoClose: 15000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });

    // Clean up the listener when the component unmounts
    return () => {
      unsubscribe();
    };
  }, []); // Empty dependency array means this effect runs once on mount

  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <HelmetProvider>
          <div className="app">
            <ToastContainer />
            <Router>
              <Routes>
                {routesConfig.map((route, index) => (
                  <Route
                    key={index}
                    path={route?.path}
                    element={route?.element}
                  />
                ))}
              </Routes>
            </Router>
            <BackToTop />
          </div>
        </HelmetProvider>
      </LocalizationProvider>
    </QueryClientProvider>
  );
};

export default App;
